import axios from 'axios';
import events from 'shared/settings/events';
import { initGlobalAxiosSettings } from './initGlobalAxiosSettings'

const axiosInstance = axios.create();
initGlobalAxiosSettings(axiosInstance);
initGenericErrorHandlerMultisite(axiosInstance);

function fireEvent(error) {
    console.error('API ERROR', error);
    let event = new CustomEvent(events.API_ERROR, {detail: error.response?.data });
    document.dispatchEvent(event);
}

export function initGenericErrorHandlerMultisite(instance) {
	instance.interceptors.response.use((response) => {
        return response;
	}, (error) => {
		if (!axios.isCancel(error)) {
			fireEvent(error);
		}
        return Promise.reject(error);
    });
}

export default axiosInstance;
